import {Injectable, inject} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {Query, QueryBody, QuerySearch, QueryValidation} from "../../../shared/services/models/query-service.model";
import {ConfigurationService} from "../../../shared/services/configuration.service";

@Injectable({
    providedIn: 'root'
})
export class QueryDataService {
    private readonly httpClient = inject(HttpClient);
    private readonly config = inject(ConfigurationService);
    private readonly api = this.config.configuration.api.backendUrl

    getQueries(): Observable<Query[]> {
        return this.httpClient.get<Query[]>(`${this.api}/configuration/query?size=999`);
    }

    deleteQuery(id: number | undefined): Observable<Query[]> {
        return this.httpClient.delete<Query[]>(`${this.api}/configuration/query/${id}`);
    }

    getQuery(id: number | undefined): Observable<Query[]> {
        return this.httpClient.get<Query[]>(`${this.api}/configuration/query/${id}`);
    }

    createQuery(query: QueryBody): Observable<QueryBody[]> {
        return this.httpClient.post<QueryBody[]>(`${this.api}/configuration/query`, query);
    }

    validateQuery(validation: QueryValidation): Observable<QueryValidation> {
        const headers = new HttpHeaders({
            'x-make-apikey': 'f8QvZ1kVKlHMop6Mt0gxxBZIYvGvB7QxD'
        });
        return this.httpClient.post<QueryValidation>(`https://hook.eu1.make.com/hdwujgoqlt3w936s9hm4y749b3q593yy`, validation, { headers });
    }

    searchQuery(name: string, search: string): Observable<QuerySearch[]> {
        return this.httpClient.get<any>(`${this.api}/configuration/query/search/searchQuery?name=${name}&search=${search}`).pipe(
            map((response: any) => response._embedded.queryViews)
        )
    }
}
